const riot = require('riot');

riot.tag2('module-record-edit', '<form class="w420 bg-white box-shadow rounded-8 p24" onsubmit="{onSubmit}"> <div class="f fm fbw mb16" if="{!opts.item.record || opts.item.record.data.is_recording !== true}"> <div class="bold lh15">{opts.item.is_preview ? \'カレンダーの予定を追加\' : (editable ? \'レコードの追加\' : \'レコードの編集\')}</div> <div class="cursor-pointer" if="{opts.item.record}" onclick="{opts.item.is_preview ? close : onDelete}"><i class="fs20 text-label_medium {opts.item.is_preview ? \'icon-close\' : \'icon-stash_box\'}"></i></div> </div> <div class="input f fm focus-primary py0 mb16"> <input class="h36 w-full" ref="title" type="text" autofocus placeholder="タスク内容を記入してください" oninput="{oninput}" onkeydown="{popup.selectionList.onKeyDown}" onblur="{onClosePopup}"><i class="icon-start fs20 text-primary cursor-pointer ml8" if="{opts.item.record &amp;&amp; !isHide}" onclick="{onStartRecorder}"></i> </div> <div class="f fm w-full mb8"> <div class="f fm"> <label class="relative mr16"> <input class="input w158 h36 focus-primary px28 focus-text-label_high" ref="project_select" riot-style="color: {currentProject ? currentProject.getColor() : app.data.project.disabledColor};" riot-value="{currentProject ? currentProject.data.name : \'\'}" placeholder="プロジェクト" onfocus="{onOpenPopupSelect}" onclick="{onOpenPopupSelect}" oninput="{projectPopup ? debounceSearchProjects : onOpenPopupSelect}" onblur="{closeProjectPopup}" onkeydown="{projectPopup.selectionList.onKeyDown}"> <div class="absolute l12 t15 z1 s8 circle mr4" if="{currentProject &amp;&amp; document.activeElement !== refs.project_select}" riot-style="background-color: {currentProject.data.color || app.utils.defaultColor};"></div><i class="absolute l8 t7 z1 icon-project text-label_medium fs16 mr4" if="{!currentProject || document.activeElement === refs.project_select}"></i><i class="icon-close absolute t7 r8 z1 text-label_medium fs16 cursor-pointer" if="{refs.project_select.value}" onclick="{onDeleteText}"></i> </label> </div> <div class="f fm w-full rounded-8 bg-background_primary overflow-hidden focus-primary pl8"><i class="icon-tag text-label_medium fs16 mr4"></i> <div class="w-full" ref="tags" data-is="atom-input-tags" onchange="{_.noop}"></div> </div> </div> <div class="w-full"> <button class="f fm rounded-4 cursor-pointer focus-primary" type="button" onclick="{onToggleOpenDescription}"><i class="icon-arrow_down text-primary transition text-gray_light fs16 mr2 {isOpen ? \'rotate-360\' : \'rotate-270\'}"></i> <div class="pr2 fs12 text-label_medium">詳細</div> </button> <div class="w-full px1 transition overflow-hidden mb8" ref="textareaContainer" riot-style="max-height:{isOpen ? refs.textareaContainer.scrollHeight : 0}px;}"> <textarea class="w-full h100 p8 rounded-8 bg-background_primary focus-primary mt4" ref="textarea" riot-value="{opts.item.record.data.description}" placeholder="詳細があれば記入してください" tabindex="{isOpen ? 0 : -1}"></textarea> </div> </div> <div class="f fm fbw"> <div class="f fm"> <div class="f fm fbw h32 w100 rounded-6 border border-separator_opaque focus-primary py7 px12 mr8"> <input class="fs12 lh15" ref="start" type="time"> <div class="cursor-pointer" ref="calendar" onclick="{onOpenPopupCalendar}"><i class="icon-calendar text-label_medium"></i></div> </div><i class="icon-arrow_right fs24 text-label_disabled mr8"></i> <input class="h32 w88 rounded-6 border border-separator_opaque focus-primary py7 px12 fs12 lh15" ref="end" type="time"> </div> <div if="{!opts.item.record || opts.item.record.data.is_recording !== true}"> <button class="button px34 py6 fs12 lh15 fw4 hover-trigger {hasValue() ? &quot;primary&quot; : &quot;disabled&quot;}" ref="saveButton" disabled="{!hasValue()}">保存</button> </div> </div> </form>', 'module-record-edit,[data-is="module-record-edit"]{display:block} module-record-edit .focus-text-label_high:focus-within,[data-is="module-record-edit"] .focus-text-label_high:focus-within{color:#2E2E38 !important}', '', function(opts) {
    this.displayProjects = [];
    this.editable = false;

    this.on('mount', async () => {
      var current_page_tag = spat.appTag.navTag.currentPageTag;
      this.isHide = current_page_tag.refs.calendar ? !!current_page_tag.refs.calendar.activeRecord : true;
      this.isOpen = !!this.opts.item.record.data?.description;

      this.editable = !this.opts.item.record || this.opts.item.is_preview;
      this.update();

      var promises = [
        app.store.collection('projects')

          .fetch(),
        app.store.collection('users').doc(app.store.currentUser.id).collection('templates').fetch({ relation: true }),

        app.store.collection('records')
          .where('created_user_ref', '==', app.store.currentUser.ref)
          .orderBy('created_at', 'desc')
          .limit(32)
          .fetch({ relation: true })
      ];

      var [projects, templates, histories] = await Promise.all(promises);
      projects.sort((a, b) => a.data.name.toLowerCase() < b.data.name.toLowerCase() ? -1 : 1);

      var unselected_project = { id: 'unselect', data: { name:'未設定' }, unselected: true };
      projects.unshift(unselected_project);

      this.update({
        projects,
        templates,
        histories,
      });

      var record = this.opts.item.record
      if (record) {
        if (record.data.title) {
          this.refs.title.value = record.data.title;
        }

        if (record.relation?.project?.doc.exists) {
          this.currentProject = this.projects.find(p => p.id === record.data.project_ref.id);
          this.update();
        }

        if (record.data.tags && record.data.tags.length) {
          this.refs.tags.setValues(record.data.tags);
        }
      }

      this.refs.start.value = dayjs(this.opts.item.start_at).format('HH:mm');
      this.refs.end.value = dayjs(this.opts.item.end_at).format('HH:mm');

      this.startDate = dayjs(this.opts.item.start_at).format('YYYY-MM-DD');
      this.endDate = dayjs(this.opts.item.end_at).format('YYYY-MM-DD');

      this.update();
      this.refs.title.focus();
      this.refs.title.select();

      this.refs.tags.on('submit', () => {
        if (this.hasValue()) {
          this.submit();
        }
      });
    });

    this.onSubmit = (e) => {
      e.preventDefault();
      this.submit();
    };

    this.submit = async () => {
      var project = null;

      project = this.currentProject;

      var start_at = dayjs(`${this.startDate} ${this.refs.start.value}`).valueOf();
      var end_at = dayjs(`${this.endDate} ${this.refs.end.value}`).valueOf();
      var diff = dayjs(end_at).diff(dayjs(start_at), 'hour');

      const ONE_DAY = 24;
      if (diff > ONE_DAY) {
        this.endDate = dayjs(this.endDate).subtract(1, 'day').format('YYYY-MM-DD');
        end_at = dayjs(`${this.endDate} ${this.refs.end.value}`).valueOf();
      }

      else if (diff < 0) {
        this.endDate = dayjs(this.endDate).add(1, 'day').format('YYYY-MM-DD');
        end_at = dayjs(`${this.endDate} ${this.refs.end.value}`).valueOf();
      }

      var data = {
        title: this.refs.title.value,
        project,
        description: this.refs.textarea.value.trim(),
        tags: this.refs.tags.getValues(),
        start_at,
        end_at,
      };

      if (this.editable) {
        this.trigger('create', {
          data,
        });
      }

      else {
        this.trigger('submit', {
          data,
        });
      }
    };

    this.onDeleteText = () => {
      this.refs.project_select.value = '';
      this.update();
    };

    this.onDelete = () => {
      this.trigger('delete');
    };

    this.close = () => {
      this.trigger('close')
    }

    this.hasValue = () => {
      return !!this.refs.title.value.trim() || this.currentProject || this.refs.tags.getValues().length;
    };

    this.onOpenPopupCalendar = async (e) => {
      const popup = spat.popup.open('popup-calendar', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetLeft: 46,
        offsetTop: 12,
        opener: this.root,
        position: 'bottom',
        opts: {
          startDate: this.startDate,
        },
      }).on('calendarselect', (date) => {
        var changed_date = date;
        var changed_date_diff = dayjs(changed_date).diff(this.startDate, 'day');
        this.startDate = changed_date;
        this.endDate = dayjs(this.endDate).add(changed_date_diff, 'day').format('YYYY-MM-DD');
        popup.close();
      });
    };

    this.getSearchProjects = () => {
      if (!this.refs.project_select) return [];

      var projects = this.refs.project_select.value ? this.displayProjects : this.projects;

      projects = projects.filter(p => !p.data.archived);
      return projects;
    };

    this.onOpenPopupSelect = async (e) => {
      if (this.projectPopup) return;

      this.refs.project_select.select();
      const POPUP_WIDTH = 266;

      let position = (window.innerWidth - POPUP_WIDTH < e.currentTarget.getBoundingClientRect().right) ? 'left' : 'right';
      this.projectPopup = spat.popup.open('popup-select', {
        element: e.currentTarget,
        align:{ y:'top' },
        position,
        offsetLeft: position === 'right' ? 16 : -16,
        opener: this.root,
        dismissible: false,
        opts: {
          options: () => { return this.getSearchProjects(); },
          kind: 'project',
          search: e.currentTarget,
        },
      }).on('select',({ option: project }) => {
        if (project && project.id === 'new') {
          this.close();
          spat.router.push('/projects/new');
          return ;
        }
        this.currentProject = !project || project.unselected ? null : project;
        this.refs.project_select.value = !project || project.unselected ?  '' : project.data.name;
        this.update();
      }).on('close', () => {
        this.projectPopup = null;
        this.update();
      });
      this.searchProjects();
    };

    this.closeProjectPopup = () => {
      if (!this.projectPopup) return;

      if (this.refs.project_select) {
        this.projectPopup.selectCurrent();
      }
      else {
        this.projectPopup.close();
      }
    };

    this.searchProjects = () => {
      if (!this.projectPopup) return ;
      const value = this.refs.project_select.value;
      const keyword = value.toLowerCase();

      this.displayProjects = this.projects.map(project => {
        const index = project.data.name.toLowerCase().indexOf(keyword);
        return { index, project };
      }).filter(item => item.index >= 0).sort((a, b) => a.index - b.index).map(item => item.project);
      this.update();
      this.projectPopup.setItems();
      this.projectPopup.update();
    };

    this.debounceSearchProjects = _.debounce(() => {
      this.searchProjects();
    }, 64);

    this.oninput = (e) => {
      e.preventUpdate = true;
      this.openTemplatesPopup(e);
      this.debouncedSearch(e);
      this.update();
    };

    this.onClosePopup = () => {
      if (!this.popup) return;
      setTimeout(() => {
        this.popup.close();
        this.popup = null;
      }, 256);
    };

    this.openTemplatesPopup = (e) => {

      e.preventDefault();
      e.stopPropagation();
      if (this.popup) {
        return;
      };
      this.popup = spat.popup.open('popup-record-list', {
        element: e.currentTarget,
        offsetTop: 0,
        opener: this.root,
        position: 'bottom',
        align: {x: 'left'},
      }).on("select", (item) => {

        if (item.data.title) {
          this.refs.title.value = item.data.title;
        }
        var project = item.relation.project;
        if (project) {

          this.currentProject = project;
        }

        if (item.data.tags && item.data.tags.length) {
          this.refs.tags.setValues(item.data.tags);
        }
        this.update();
      }).on('close', () => {
        this.popup = null;
        this.update();
      });
      this.update();
    };

    this.debouncedSearch = _.debounce((e) => {
      this.updateSearch(e);
      this.update();
    }, 128);

    this.updateSearch = (e) => {
      var str = e.target.value.toLowerCase();

      if (this.templates) {
        var update_templates = this.getFilteredString(this.templates, str);
      }

      if (this.histories) {
        var update_histories = this.getFilteredString(this.histories, str);
      }

      if (update_histories && update_templates) {

        update_templates = update_templates.filter((template) => {
          return !update_histories.find(history => template.data.title === history.data.title && template.data.project_ref?.id === history.data.project_ref?.id);
        });
      }

      this.popup.setTemplates(update_templates);
      this.popup.setRecentHistoryRecords(update_histories);
    };

    this.getFilteredString = (items, str) => {
      return items.filter(item => {
        return item.data.title.toLowerCase().includes(str);
      });
    };

    this.onStartRecorder = (e) => {

      this.bubbleTrigger('startrecorder', this.opts.item.record);
    };

    this.onToggleOpenDescription = (e) => {
      this.isOpen = !this.isOpen;
      this.update();
    };
});